import { InputText } from 'primereact/inputtext';
import { ScrutinyTab } from '../ScrutinyTab';
import { Button } from 'primereact/button';
import { useEffect, useRef, useState } from 'react';
import { LetterShowClick } from '../../../config/Validate';
import { Toast } from 'primereact/toast';
import { TabPanel, TabView } from 'primereact/tabview';
import { getAllDetails } from '../../../service/ProductService';
import { SCRUTINYLIST } from '../../../config/ApiConstant';
import { freshApplicationOtherStateName, SCHECK, SHOLD, SkeletonbodyTemplate, Skeletonitems, SPREPARE, SVERIFICATION } from '../../../appconfig/Settings';
import { formatDate, setScrutinyActiveTab } from '../../../appconfig/AppHelper';
import { useNavigate, useParams } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { combinedFullNameTemplate, commonNameTemplate, dateTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { ScrutinyListColumns } from '../../../appconfig/DatatableSetting';
import { Badge } from 'primereact/badge';
import { Dialog } from 'primereact/dialog';

export const OtherStateScrutiny = () => {
    document.title = 'Fresh Registration (Other State) Scrutiny | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //scrutinyRemainingList
    const [scrutinyRemainingList, setScrutinyRemainingList] = useState<any>([]);
    const [scrutinyRemaining, setScrutinyRemaining] = useState<any>(true);
    const [applicationDetails, setApplicationDetails] = useState<any>({});
    const [searchResult, setSearchResult] = useState<any>(false);

    //duplicateata
    const [duplicateData, setDuplicateData] = useState<any>([]);
    const [duplicateModal, setDuplicateModal] = useState<any>(false);

    //tabIndex
    const [activeIndex, setActiveIndex] = useState<any>(0);

    //fileNO
    const [fileNo, setFileNo] = useState<any>(null);

    // errors
    const [errors, setErrors] = useState<any>({});

    //role
    const [roleName, setRoleName] = useState<any>(null);

    //loaders
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [showLoading, setShowLoading] = useState<boolean>(false);

    const { status }: any = useParams();

    //navigate
    const naviagte = useNavigate();

    useEffect(() => {
        // Get Token from LocalStorage
        let token: any = localStorage.getItem('token');
        let role: any = localStorage.getItem('role');

        //Token Decode
        if (!window.cn(role)) {
            const { myUserObject } = JSON.parse(window.atob(token.split('.')[1]));
            if (!window.cn(role)) {
                let roleNm = role;
                let selectedTab = activeIndex === 0 ? setScrutinyActiveTab(roleNm) : atob(status);
                setActiveIndex(Number(selectedTab));
                setRoleName(roleNm);
            }
        }
    }, [status]);

    useEffect(() => {
        if (!window.cn(roleName) && !window.cn(activeIndex)) {
            getRemainingScrutinyList();
        }
    }, [roleName, activeIndex]);

    // Get Remaining Scrutiny List
    const getRemainingScrutinyList = async () => {
        try {
            setPageLoad(false);
            // List Fetch for Scrutiny Manager
            if (activeIndex === 0) {
                const response = await getAllDetails(SCRUTINYLIST + '?AppNm=' + freshApplicationOtherStateName + '&applicationStatusType=' + SVERIFICATION);
                if (response) {
                    setScrutinyRemainingList(response);
                    setPageLoad(true);
                }
            }

            // List Fetch for Sub-Registrar
            if (activeIndex === 1) {
                const response = await getAllDetails(SCRUTINYLIST + '?AppNm=' + freshApplicationOtherStateName + '&applicationStatusType=' + SPREPARE);
                if (response) {
                    setScrutinyRemainingList(response);
                    setPageLoad(true);
                }
            }

            // List Fetch for Registrar
            if (activeIndex === 2) {
                const response = await getAllDetails(SCRUTINYLIST + '?AppNm=' + freshApplicationOtherStateName + '&applicationStatusType=' + SCHECK);
                if (response) {
                    setScrutinyRemainingList(response);
                    setPageLoad(true);
                }
            }

            // List Fetch for Registrar Hold Applications
            if (roleName === 'Registar' && activeIndex === 3) {
                const response = await getAllDetails(SCRUTINYLIST + '?AppNm=' + freshApplicationOtherStateName + '&applicationStatusType=' + SHOLD);
                if (response) {
                    setScrutinyRemainingList(response);
                    setPageLoad(true);
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPageLoad(true);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    const searchScrutiny = async (fileNo: any) => {
        try {
            const { errors, isError } = LetterShowClick(fileNo);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setShowLoading(true);
                setScrutinyRemaining(false);

                naviagte(`/app/scrutiny/other-state-scrutiny/${window.btoa(activeIndex)}/${window.btoa(fileNo)}`);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setShowLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    //verificationStatus
    const verificationStatusTemplate = (rowData: any) => {
        return <div className="actions">{rowData?.verification_status === 1 ? <Badge value="True" severity="success"></Badge> : '-'}</div>;
    };

    //file No Template
    const fileNoTemplate = (rowData: any) => {
        return (
            <>
                <div className="avatar-div ">
                    <div className="emp-name link-name" onClick={() => searchScrutiny(rowData?.SrNo)} style={{ cursor: 'pointer' }}>
                        {rowData?.SrNo}
                    </div>
                </div>
            </>
        );
    };

    //action Template
    const actionTemplate = (rowData: any) => {
        return (
            <div className="actions">
                <Button
                    label="Verification List"
                    style={{ width: 'max-content' }}
                    onClick={() => naviagte(`/app/scrutiny/verificationList/${window.btoa(rowData?.SrNo)}`)}
                    disabled={rowData?.verification_status == 0 ? true : false}
                    className="mr-2"
                ></Button>
                <Button label="Scrutiny" style={{ width: 'max-content' }} className="p-button p-button-success" onClick={() => searchScrutiny(rowData?.SrNo)}></Button>
            </div>
        );
    };

    // hidedupliactedialog
    const hideDuplicateDialog = () => {
        setDuplicateModal(false);
    };
    // Get Name
    let name = !window.cn(applicationDetails?.StudL) ? applicationDetails?.StudL : '' + ' ' + !window.cn(applicationDetails?.StudF) ? applicationDetails?.StudF : '' + ' ' + !window.cn(applicationDetails?.StudM) ? applicationDetails?.StudM : '';

    return (
        <>
            <ScrutinyTab mainTabLabel="Scrutiny (Other State)" />
            <Toast ref={toast} />

            <div className="grid crud-demo mt-4">
                <div className="col-12">
                    <div className="card">
                        <div className="p-fluid formgrid grid align-items-center">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="regNo">
                                    File No <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText
                                    value={!window.cn(fileNo) ? fileNo : ''}
                                    name="fileNo"
                                    keyfilter="num"
                                    autoComplete="off"
                                    placeholder="Enter File No."
                                    onChange={(e) => setFileNo(e.target.value)}
                                    className={errors['fileNo'] && 'p-invalid'}
                                />
                                <small className="p-invalid-txt">{errors['fileNo']}</small>
                            </div>
                            <div className="field col-12 md:col-1 mt-4">
                                <Button label="Search" className="p-button-primary" onClick={() => searchScrutiny(fileNo)} loading={showLoading} />
                            </div>
                        </div>

                        {searchResult ? (
                            <>
                                <hr />
                                <div className="grid mt-2">
                                    <div className="field col-12 md:col-5">
                                        <div className="flex mb-3">
                                            <b className="detail_title" style={{ minWidth: '100px' }}>
                                                Full Name :{' '}
                                            </b>
                                            <p className="detail_name">{name}</p>
                                        </div>
                                        <div className="flex mb-3">
                                            <b className="detail_title" style={{ minWidth: '100px' }}>
                                                App Status :
                                            </b>
                                            <p className="detail_name">{applicationDetails?.appStatus === 'Approved' ? <Badge value="Approved" severity="success"></Badge> : <Badge value={applicationDetails?.appStatus} severity="warning"></Badge>}</p>
                                        </div>
                                        <div className="flex">
                                            <b className="detail_title" style={{ minWidth: '100px' }}>
                                                Date :
                                            </b>
                                            <p className="detail_name">{!window.cn(applicationDetails.EntDt) ? formatDate(applicationDetails.EntDt) : ''}</p>
                                        </div>
                                    </div>
                                    <div className="field  col-12 md:col-3">
                                        <div className="flex mb-3">
                                            <b className="detail_title" style={{ minWidth: '100px' }}>
                                                File No :
                                            </b>
                                            <p className="detail_name">{applicationDetails.SrNo}</p>
                                        </div>
                                        <div className="flex">
                                            <b className="detail_title" style={{ minWidth: '100px' }}>
                                                Verified By :
                                            </b>
                                            <p className="detail_name">{!window.cn(applicationDetails.verified_by) ? applicationDetails.verified_by : ''}</p>
                                        </div>
                                    </div>
                                    <div className="field flex flex-column col-12 md:col-4 align-items-end">
                                        <img
                                            src={applicationDetails?.Image}
                                            style={{
                                                border: '1px solid black'
                                            }}
                                            alt="User"
                                            width={'120px'}
                                        />
                                        <div className="flex mt-3">
                                            <Button label="Check Duplicate" className="mr-2" onClick={() => setDuplicateModal(true)}></Button>
                                            <Button label="View Document"></Button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            ''
                        )}

                        <hr />

                        {scrutinyRemaining ? (
                            <>
                                {roleName == 'Register' ? (
                                    <>
                                        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                                            <TabPanel header="Scrutiny Verification"></TabPanel>
                                            <TabPanel header="Scrutiny Prepare"></TabPanel>
                                            <TabPanel header="Scrutiny Check"></TabPanel>
                                            <TabPanel header="Scrutiny Hold"></TabPanel>
                                        </TabView>
                                    </>
                                ) : (
                                    <>
                                        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                                            <TabPanel header="Scrutiny Verification"></TabPanel>
                                            <TabPanel header="Scrutiny Prepare"></TabPanel>
                                            <TabPanel header="Scrutiny Check"></TabPanel>
                                        </TabView>
                                    </>
                                )}
                                {/* Datatable */}
                                {pageLoad ? (
                                    <>
                                        <DataTable
                                            value={scrutinyRemainingList}
                                            showGridlines
                                            stripedRows
                                            globalFilter={globalFilter}
                                            filters={globalFieldFilter}
                                            onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                            className="datatable-responsive p-datatable-sm"
                                            emptyMessage="No Data Found"
                                            removableSort
                                        >
                                            {ScrutinyListColumns.map((col: any, i: any) => {
                                                if (col.field === 'PayDt') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                                } else if (col.field === 'remainder_date') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                                } else if (col.field === 'BOD') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                                } else if (col.field === 'verification_date') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                                } else if (col.field === 'name') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={combinedFullNameTemplate} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                                } else if (col.field === 'verification_status') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={verificationStatusTemplate} />;
                                                } else if (col.field === 'action') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={actionTemplate} />;
                                                } else if (col.field === 'ColName') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={commonNameTemplate} />;
                                                } else if (col.field === 'sr_no') {
                                                    return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '5rem' }} />;
                                                } else if (col.field === 'SrNo') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={fileNoTemplate} />;
                                                } else {
                                                    return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                                }
                                            })}
                                        </DataTable>
                                    </>
                                ) : (
                                    <>
                                        {/* Skeleton Data table */}
                                        <DataTable value={Skeletonitems}>
                                            {ScrutinyListColumns.map((col: any, i: any) => (
                                                <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                            ))}
                                        </DataTable>
                                    </>
                                )}
                            </>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </div>

            {/* Duplicate Modal Start */}

            <Dialog visible={duplicateModal} style={{ width: '750px' }} header={'Duplicate Data'} modal onHide={hideDuplicateDialog}>
                <div className="p-2">
                    <DataTable value={duplicateData} emptyMessage="No Data Found">
                        <Column field="SrNo" header="SrNo"></Column>
                        <Column field="RegNo" header="Reg No"></Column>
                        <Column field="BOD" header="DOB" body={dateTemplate}></Column>
                        <Column field="name" header="Name" body={combinedFullNameTemplate}></Column>
                    </DataTable>
                </div>
            </Dialog>
            {/* Duplicate Modal End */}
        </>
    );
};
